import React from 'react';

const CardTable = props => {
  const {
    renderHeaders,
    renderRows,
  } = props;

  return (
    <>
      <table className='updated-card-table'>
        <thead>
          <tr>
            {renderHeaders()}
          </tr>
        </thead>
        <tbody>
          {renderRows()}
        </tbody>
      </table>
    </>
  )
}


export default CardTable;